import homePage from "../pages/home";
import servicesPage from "../pages/services";
import aboutPage from "../pages/about";
import hospitalsPage from "../pages/hospitals";
import testimonialsPage from "../pages/testimonials";
import contactPage from "../pages/contact";
import privacyPolicyPage from "../pages/privacy-policy";
import termsPage from "../pages/terms";
import hotelPage from "../pages/hotel";
import dentalPage from "../pages/dental";
import hairPage from "../pages/hair";
import plasticPage from "../pages/plastic";
import plasticBodyPage from "../pages/plastic-body";
import bariatricPage from "../pages/bariatric";
import aestheticsPage from "../pages/aesthetics";
import airportPage from "../pages/airport";
import conciergePage from "../pages/concierge";
import transfersPage from "../pages/transfers";
import interpreterPage from "../pages/interpreter";
import privacyServicePage from "../pages/privacy-service";
import notFoundPage from "../pages/not-found";
import treatmentPage from "../pages/treatment";
import treatments from "../content";

const routes = {
  "/": homePage,
  "/services": servicesPage,
  "/about": aboutPage,
  "/hospitals": hospitalsPage,
  "/testimonials": testimonialsPage,
  "/contact": contactPage,
  "/privacy-policy": privacyPolicyPage,
  "/terms": termsPage,
  "/hotel": hotelPage,
  "/dental": dentalPage,
  "/hair": hairPage,
  "/plastic": plasticPage,
  "/plastic-body": plasticBodyPage,
  "/bariatric": bariatricPage,
  "/aesthetics": aestheticsPage,
  "/airport": airportPage,
  "/concierge": conciergePage,
  "/transfers": transfersPage,
  "/interpreter": interpreterPage,
  "/privacy": privacyServicePage,

};

// Treatment pages — one real page per operation, built from src/content/. The
// route is the slug the module declares, so adding a page means adding a file.
const treatmentRoutes = Object.fromEntries(
  treatments.map((content) => [content.slug, () => treatmentPage(content)])
);

Object.assign(routes, treatmentRoutes);

export { notFoundPage };
export default routes;
